export const usersEmailsToUsersNames = (
    userEmails: string[],
    emailToName: Record<string, string>,
): string[] => {
    return userEmails.map(email => emailToName?.[email] || email);
};
